import { ProjectHeader } from "./project_header";
import { useProject } from "./helpers";
import { usePageData } from "../utils/api";
import { toast } from "react-toastify";
import { useState } from "react";
import { ArrowRight } from "lucide-react";

export const Discover = () => {
  const { project, refetch: refetchProject } = useProject();
  const [question, setQuestion] = useState("");
  const [isSimpleMode, setIsSimpleMode] = useState(false);
  const { data } = usePageData();

  if (!project) {
    return null;
  }

  const termPrompt =
    "I keep hearing about the following term/phrase. What could it mean?";
  const questionPrompt = "Answer the following question:\n";

  const copyToClipboard = () => {
    let text = data?.text || "";
    text += "\n\nBased on the above context, ";

    if (isSimpleMode) {
      text += `${termPrompt}\n"${question}"`;
    } else {
      text += `${questionPrompt}\n${question}`;
    }

    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard");
  };

  return (
    <div>
      <ProjectHeader project={project} refetch={refetchProject} />

      <div className="row">
        <div className="col-md-6">
          <h4 className="mb-2">Context</h4>
          <div
            className="pre-wrap border rounded p-2 bg-light fs-14 position-relative"
            style={{ height: 200, overflow: "scroll" }}
          >
            {data?.text}
          </div>
          <div className="mt-1 text-muted fs-14">
            Character Count: {data?.text?.length}
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-2">
            <h4 className="mb-2">Ask a Question</h4>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="questionType"
                id="openQuestion"
                checked={!isSimpleMode}
                onChange={() => setIsSimpleMode(false)}
              />
              <label className="form-check-label" htmlFor="openQuestion">
                Open Question
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="questionType"
                id="termLookup"
                checked={isSimpleMode}
                onChange={() => setIsSimpleMode(true)}
              />
              <label className="form-check-label" htmlFor="termLookup">
                Term/Phrase Lookup
              </label>
            </div>
          </div>

          {isSimpleMode ? (
            <>
              {termPrompt}
              <input
                type="text"
                className="form-control mt-1"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
              />
            </>
          ) : (
            <>
              {questionPrompt}
              <textarea
                className="form-control mt-1"
                rows={3}
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
              />
            </>
          )}

          <div className="mt-3">
            <button className="btn btn-primary" onClick={copyToClipboard}>
              Copy to clipboard
              <i className="bi bi-clipboard ml-1" />
            </button>
            <ArrowRight size={16} className="mx-3" />
            <a href="https://chatgpt.com/" target="_blank" className="btn btn-primary">
              <i className="bi bi-chat-dots me-2"></i>
              Ask ChatGPT
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
